import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { SidebarComponent } from '.'
import { $el } from 'src/scripts/utils/utils'

const BUTTON_SELECTOR = `[data-sidebar-button]`

export class SidebarButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(this, 'keydown', this.handleKeyDown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    if (!(<HTMLElement>event.target).closest('[href]')) {
      event.preventDefault()
      this.toggle(event)
    }
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.toggle(event)
    }
  }

  toggle(event): void {
    const button = $el(BUTTON_SELECTOR, this)
    const sidebar: SidebarComponent = $el(`#${button.dataset.sidebarId}`)

    sidebar?.toggle(event)
    button?.classList.toggle('is-opened', sidebar?.isOpen)
  }
}
